// server.js
const SERVER_API_URL = 'http://backend.bizzcountsolutions.com'; 
// const SERVER_API_URL = 'http://localhost:8000'; 

export { SERVER_API_URL };